import React from 'react';
import PropTypes from 'prop-types';
import {noop} from 'lodash';
import PortfolioList from '../containers/portfolio-list/portfolio-list';
import Loading from './loading';
import PortfolioSectionHeader from 'shared/portfolio/components/portfolio-section-header';
import Card from 'src/components/Cards/Card';
import PortfolioIcon from 'shared/portfolio/components/portfolio-icon/portfolio-icon';
import {startedScholarships} from '../utils';
import 'stylesheets/components/college-success/college-success.scss';
import CarouselDisplay from './CarouselDisplay';

export default class CollegeSuccess extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    collegeSuccessItemTypes: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        emoji: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ).isRequired,
    getCollegeSuccessItemTypes: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    showCarousel: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    showCarousel: true,
  };

  componentDidMount() {
    this.props.getCollegeSuccessItemTypes();
  }

  render() {
    const {title, subtitle, collegeSuccessItemTypes, loading, showCarousel} = this.props;
    const collegeSuccessItems = startedScholarships(collegeSuccessItemTypes);
    const CarouselComponent = () => {
      if (loading) {
        return <Loading />;
      }

      return <CarouselDisplay collegeSuccessItems={collegeSuccessItems} />;
    };

    return (
      <section className="college-success" data-testid="college-success">
        <PortfolioSectionHeader
          title={title}
          displayNew={false}
          addNew={noop}
          sectionName="college-success"
        >
          <PortfolioIcon type="collegeSuccess" />
        </PortfolioSectionHeader>
        <Card width="100%">
          <p className="college-success-title">{subtitle}</p>
          {showCarousel && <CarouselComponent />}
          <PortfolioList />
        </Card>
      </section>
    );
  }
}
